import React from "react";
import styled, { css } from "styled-components";
import { Theme } from "../../theme";

const Svg = styled.svg`
    width: 15px;
    height: 30px;
    vertical-align: middle;
    display: inline-block;

    ${(props) =>
        props.md &&
        css`
            width: 15px * 0.75;
            height: 30px * 0.75;
        `}

    polyline {
        fill: none;
        stroke: ${Theme.colors.red};
        stroke-width: 2;
        stroke-linecap: round;
        [disabled] & {
            stroke: ${Theme.colors.gray[400]};
        }

        ${(props) =>
            props.stroke &&
            css`
                stroke: ${props.stroke};
            `}
    }

    ${(props) =>
        props.back &&
        css`
            transform: scaleX(-1);
        `}
`;

export const UspsCarrat = (props) => {
    return (
        <Svg viewBox="0 0 8 12" {...props}>
            <polyline points="1.7,10.3 6.1,5.9 1.7,1.5 " />
        </Svg>
    );
};
